import { render, staticRenderFns } from "./DosMediaU2.vue?vue&type=template&id=344a5652&scoped=true&"
import script from "./DosMediaU2.vue?vue&type=script&lang=js&"
export * from "./DosMediaU2.vue?vue&type=script&lang=js&"
import style0 from "./DosMediaU2.vue?vue&type=style&index=0&id=344a5652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344a5652",
  null
  
)

export default component.exports